import { render } from "./DrawSignatureView.vue?vue&type=template&id=6b032a9e"
import script from "./DrawSignatureView.vue?vue&type=script&lang=js"
export * from "./DrawSignatureView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__